import DEFINE, { PATHS } from './../constants/Define';

export default [{
    title: 'userMembers',
    tagSub: "userMembers",
    exact: false,
    path: PATHS.USER.path,
    show: true,
    icon: "faUserCog",
    isParrentMenu: true,
    routeName: DEFINE.GENERAL.ROUTE_NAME.USER_MANAGEMENT,
    permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
    children: [
        {
            title: "users",
            group: "users",
            tagSub: "userMembers",
            path: PATHS.USER.LIST.path,
            exact: false,
            icon: 'user',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.USER,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
            children: [
                {
                    title: "createUsers",
                    group: "users",
                    tagSub: "userMembers",
                    path: '/users/action',
                    exact: false,
                    icon: 'user',
                    show: false,
                }, {
                    title: "updateUsers",
                    group: "users",
                    tagSub: "userMembers",
                    path: '/users/action/:id',
                    exact: false,
                    icon: 'user',
                    show: false,
                }
            ]
        }, {
            title: "roles",
            group: "roles",
            tagSub: "userMembers",
            path: PATHS.ROLE.LIST.path,
            exact: false,
            icon: 'apartment',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.ROLE,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
            children: [
                {
                    title: "createRoles",
                    group: "roles",
                    tagSub: "userMembers",
                    path: '/roles/action',
                    exact: false,
                    icon: 'apartment',
                    show: false,
                }, {
                    title: "updateRoles",
                    group: "roles",
                    tagSub: "userMembers",
                    path: '/roles/action/:id',
                    exact: false,
                    icon: 'apartment',
                    show: false,
                }
            ]
        }
    ],
}]